module.exports = __webpack_public_path__ + "static/media/gratitude-wild-in-art.2bb99a32.png";